import { Strategy } from "./ancillary.js";
import { isGetterDescriptor, memoizeGetter } from "./getter.js";
import { isMethodDescriptor, memoizeMethod } from "./method.js";
export * from "./ancillary.js";
function defaultDigest(...args) {
    let result = "";
    for (let i = 0, length = args.length; i < length; i++) {
        result += `${args[i]}$!$`;
    }
    return result;
}
export function memoize(params) {
    const hashFunction = params?.hashFunction || defaultDigest;
    const strategy = params?.strategy || Strategy.WEAKMAP;
    const argsCacheBuilder = params?.argsCacheBuilder || (() => new Map());
    return (target, propertyKey, descriptor) => {
        if (isMethodDescriptor(descriptor)) {
            memoizeMethod(descriptor, propertyKey, strategy, hashFunction, argsCacheBuilder);
            return;
        }
        if (isGetterDescriptor(descriptor)) {
            memoizeGetter(descriptor, propertyKey, strategy);
            return;
        }
        throw new Error("Decorate only a method or get accessor");
    };
}
export const Memoize = memoize;
